// Lightweight CSS-driven floating particles. Performance: ~12 absolutely-positioned
// divs animated by Framer Motion. No canvas, no setInterval, ~zero CPU when offscreen.
import { motion } from "framer-motion";

const PARTICLES = [
  { x: 8, y: 20, size: 3, dur: 14, delay: 0 },
  { x: 18, y: 70, size: 2, dur: 18, delay: 2 },
  { x: 30, y: 35, size: 4, dur: 22, delay: 1 },
  { x: 45, y: 80, size: 2, dur: 16, delay: 3 },
  { x: 55, y: 15, size: 3, dur: 20, delay: 0.5 },
  { x: 65, y: 60, size: 5, dur: 24, delay: 4 },
  { x: 72, y: 25, size: 2, dur: 17, delay: 1.5 },
  { x: 80, y: 70, size: 3, dur: 21, delay: 2.5 },
  { x: 88, y: 40, size: 4, dur: 19, delay: 0.8 },
  { x: 95, y: 85, size: 2, dur: 15, delay: 3.2 },
  { x: 12, y: 50, size: 3, dur: 23, delay: 4.5 },
  { x: 38, y: 90, size: 2, dur: 16, delay: 5 },
];

export default function FloatingParticles({ color = "#E6C662" }) {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
    >
      {PARTICLES.map((p, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full"
          style={{
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: p.size,
            height: p.size,
            background: color,
            boxShadow: `0 0 ${p.size * 4}px ${color}`,
          }}
          animate={{
            y: [0, -40, 0],
            opacity: [0.15, 0.6, 0.15],
          }}
          transition={{
            duration: p.dur,
            delay: p.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
      {/* Soft radial vignette to anchor focus */}
      <div
        className="absolute inset-0"
        style={{
          background: `radial-gradient(ellipse at center, transparent 0%, transparent 50%, rgba(0,0,0,0.4) 100%)`,
        }}
      />
    </div>
  );
}
